import type { NeedsPluginResponse } from '@zinc/shared';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router';
import { api } from '../../lib/api';
import { Panel, tinyButton } from './parts';

/** Admin → Needs a plugin: missing rules grouped by what is unmapped, most common first, each
 * with "Copy request for Claude Code". */
export function AdminNeedsPluginPage() {
  const data = useQuery({
    queryKey: ['admin', 'needs-plugin'],
    queryFn: () => api<NeedsPluginResponse>('/api/admin/needs-plugin'),
  });
  const [copied, setCopied] = useState<string | null>(null);
  const copy = async (signature: string, text: string) => {
    await navigator.clipboard?.writeText(text);
    setCopied(signature);
    window.setTimeout(() => setCopied((c) => (c === signature ? null : c)), 2000);
  };
  return (
    <>
      <h1 className="m-0 text-[26px] font-bold">Needs a plugin</h1>
      <p className="m-0 text-[14px] text-muted">
        {data.data?.total ?? 0} puzzles are playable without rule checking until their rules have a
        plugin. After a plugin ships, run Batch jobs → Retry needs-a-plugin puzzles.
      </p>
      {(data.data?.groups ?? []).map((g) => (
        <Panel
          key={g.signature}
          title={`${g.count} ${g.count === 1 ? 'puzzle' : 'puzzles'}`}
          side={
            <button
              type="button"
              className={tinyButton}
              onClick={() => void copy(g.signature, g.request)}
            >
              {copied === g.signature ? 'Copied' : 'Copy request for Claude Code'}
            </button>
          }
        >
          <p className="m-0 text-[14px] font-semibold">{g.signature}</p>
          <ul className="m-0 flex flex-col gap-1 pl-5 text-[13px]">
            {g.puzzles.slice(0, 8).map((p) => (
              <li key={p.id}>
                <Link to={`/puzzle/${p.id}`}>{p.title}</Link>
                {p.setter && <span className="text-muted"> by {p.setter}</span>}
              </li>
            ))}
            {g.puzzles.length > 8 && (
              <li className="text-muted">and {g.puzzles.length - 8} more</li>
            )}
          </ul>
        </Panel>
      ))}
    </>
  );
}
